<template>
    <blank-layout>


        <div class="-mt-6 flex flex-grow flex-col">

            <div class="flex flex-col md:flex-row w-full flex-grow">



                <div class="flex flex-grow bg-white flex-col justify-center items-center">








                    <div class="flex flex-col w-full max-w-xl">



                        <!-- <div v-if="google_ids.id != ''"
                            class="alert alert-primary" role="alert">
                                This Google account is unknown: you are welcome to sign up for a new account!<br />
                                <small>You can also <a href="/login">go back to sign in page</a> if you want to login with an existing account.</small>
                        </div> -->

                        <div v-if="integration_type == 'intercom'">
                            <h1 class="text-center">Get started with Birdie</h1>
                            <p class="text-center text-primary">Add your contact details to activate your Intercom App.
                            </p>
                        </div>
                        <div v-else-if="integration_type == 'aircall'">
                            <h1 class="text-center">Get started with Birdie</h1>
                            <p class="text-center text-primary">Add your contact details to activate your Aircall App.
                            </p>
                        </div>
                        <div v-else-if="integration_type == 'zendesk'">
                            <h1 class="text-center">Get started with Birdie</h1>
                            <p class="text-center text-primary">Add your contact details to activate your Zendesk App.
                            </p>
                        </div>
                        <div v-else-if="integration_type == 'helpscout'">
                            <h1 class="text-center">Get started with Birdie</h1>
                            <p class="text-center text-primary">Add your contact details to activate your Helpscout
                                integration.</p>
                        </div>
                        <div v-else-if="integration_type == 'freshchat'">
                            <h1 class="text-center">Get started with Birdie</h1>
                            <p class="text-center text-primary">Add your contact details to activate your Freshchat App.
                            </p>
                        </div>
                        <div v-else-if="integration_type == 'jira'">
                            <h1 class="text-center">Get started with Birdie</h1>
                            <p class="text-center text-primary">Add your contact details to activate Jira Service
                                Management App.</p>
                        </div>
                        <div v-else-if="integration_type == 'salesforce'">
                            <h1 class="text-center">Get started with Birdie</h1>
                            <p class="text-center text-primary">Add your contact details to activate Salesforce App.</p>
                        </div>

                        <div v-else class="flex justify-center items-center flex-col mb-10">

                            <img src="/img/logo-black-website.svg" width="160" alt="Logo" class="" />

                            <!-- <h1 class="text-center text-blue-500 text-4xl font-bold">

                            </h1>
                            <div class="w-full max-w-xl px-6 my-6">
                                <div class="w-full h-2 rounded-full bg-gray-200">
                                    <div class="w-1/2 h-2 bg-yellow-300 rounded-full"></div>
                                </div>
                            </div> -->

                            <!-- <p class="text-center text-gray-700 text-xl">Add your contact details to signup.</p> -->
                        </div>



                        <p>&nbsp;</p>

                        <jet-form @submitted="submitSignup">

                            <template #form>

                                <h2 class="text-left text-gray-700 font-bold text-2xl">Let’s get your account set up
                                </h2>

                                <div class="mt-6">
                                    <jet-label for="fullname" value="Full name" class="font-bold text-base" />
                                    <jet-input id="fullname" type="text" class="mt-1 block w-full"
                                        v-model="form.fullname" ref="fullname" autocomplete="fullname"
                                        placeholder="John Doe" />
                                    <jet-input-error :message="form.errors.fullname" class="mt-2" />
                                </div>

                                <div class="mt-6">
                                    <jet-label for="email" value="Email" class="font-bold text-base" />
                                    <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email"
                                        ref="email" autocomplete="email" placeholder="john@empire.com"
                                        @update:modelValue="changeEmailValue" />
                                    <jet-input-error :message="form.errors.email" class="mt-2" />
                                    <!-- <transition name="slide-fade" mode="out-in"> -->


                                    <div class="text-sm text-blue-600 bg-blue-100 px-3 py-1.5 -mt-1 -mb-6 rounded-b-md transition duration-300"
                                        :class="{ 'opacity-0': !show_info_email && !sso_redirect }">
                                        <div v-if="sso_redirect">
                                            Single Sign-On is required for this domain <a :href="sso_redirect"
                                                title="Sign in with SSO" class="underline hover:text-blue-700">go to
                                                sign-in</a>
                                        </div>
                                        <div v-else>
                                            An account already exists for this email, <a
                                                :href="route('login', { email: form.email })" title="Sign in"
                                                class="underline hover:text-blue-700">go to sign-in
                                                page?</a>
                                        </div>
                                    </div>
                                    <!-- </transition> -->
                                </div>

                                <div class="mt-6">
                                    <jet-label for="company" value="Company" class="font-bold text-base" />
                                    <jet-input id="company" type="text" class="mt-1 block w-full" v-model="form.company"
                                        ref="company" autocomplete="company" placeholder="Empire"
                                        @update:modelValue="changeCompanyName" debounce="500" />
                                    <jet-input-error :message="form.errors.company" class="mt-2" />
                                    <!-- <transition name="slide-fade" mode="out-in"> -->
                                    <div class="text-sm text-blue-600 bg-blue-100 px-3 py-1.5 -mt-1 rounded-b-md transition duration-300"
                                        :class="{ 'opacity-0': !show_info_company }">
                                        Looks like an account already exist for this company name. Ask the owner for an
                                        invitation if you want to join.
                                    </div>
                                    <!-- </transition> -->
                                </div>

                                <div class="mt-3 mb-5 hidden">
                                    <jet-label for="" value="What best describes what you do?"
                                        class="font-bold text-base" />
                                    <options-radio :options="[{ label: 'General Support', value: 'general_support' },
                                    { label: 'Technical Support', value: 'technical_support' },
                                    { label: 'Customer Success', value: 'customer_success' },
                                    { label: 'Other', value: 'other' }]" checked=""
                                        @update="updatedJob"></options-radio>
                                    <jet-input-error :message="form.errors.job" class="mt-2" />
                                </div>


                            </template>

                            <template #actions>

                                <div class="flex flex-col flex-grow -mt-6">
                                    <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                                        Saved.
                                    </jet-action-message>

                                    <jet-button :class="{ 'opacity-25 cursor-default': searching }"
                                        :disabled="searching || !is_complete">
                                        <span v-if="integration_type == 'intercom'">Install Intercom App</span>
                                        <span v-else-if="integration_type == 'zendesk'">Install Zendesk App</span>
                                        <span v-else-if="integration_type == 'aircall'">Install Aircall App</span>
                                        <span v-else>Continue</span>
                                    </jet-button>

                                    <small id="signupHelp" class="form-text text-muted optin pt-2">By signing up, you
                                        agree to our <a href="https://www.birdie.so/legal#TermsOfService"
                                            target="_blank" title="Terms of Service"
                                            class="text-blue-900 hover:text-blue-700 hover:underline">Terms of
                                            Service</a> and <a href="https://www.birdie.so/legal#PrivacyPolicy"
                                            target="_blank" class="text-blue-900 hover:text-blue-700 hover:underline"
                                            title="Privacy Policy">Privacy Policy</a>.</small>
                                </div>

                            </template>

                        </jet-form>


                    </div>


                </div>



                <div v-if="integration_type == 'intercom'"
                    class="sidebar_gradient hidden lg:flex flex-grow md:flex-grow-0 md:w-1/3 bg-gray-100 flex-col justify-center px-4">
                    <div class="">
                        <h3 class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/intercom-full-dark.svg" width="160" alt="Intercom Logo"
                                class="intercom-logo" />
                        </h3>
                        <p class="text-center p-10 text-gray-700">Give your customers a handy way to send you Screen
                            Recordings right
                            from your Messenger.</p>
                    </div>
                </div>
                <div v-else-if="integration_type == 'aircall'"
                    class="sidebar_gradient hidden lg:flex flex-grow md:flex-grow-0 md:w-1/3 bg-gray-100 flex-col justify-center px-4">
                    <div class="">
                        <h3 class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/aircall_logo.svg" width="120" alt="Aircall Logo" class="aircall-logo" />
                        </h3>
                        <p class="text-center p-10 text-gray-700">Sit next to your customers.</p>
                    </div>
                </div>
                <div v-else-if="integration_type == 'zendesk'"
                    class="sidebar_gradient hidden lg:flex flex-grow md:flex-grow-0 md:w-1/3 bg-gray-100 flex-col justify-center px-4">
                    <div class="">
                        <h3 class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/zendesk-full-dark.svg" width="140" alt="Zendesk Logo" class="zendesk-logo"
                                style="margin-top:-6px;" />
                        </h3>
                        <p class="text-center p-10 text-gray-700">Give your customers a handy way to send you Screen
                            Recordings right
                            from your Helpdesk.</p>
                    </div>
                </div>
                <div v-else-if="integration_type == 'helpscout'"
                    class="sidebar_gradient hidden lg:flex flex-grow md:flex-grow-0 md:w-1/3 bg-gray-100 flex-col justify-center px-4">
                    <div class="">
                        <h3 class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/helpscout-logo.svg" width="140" alt="Helpscout Logo" class="helpscout-logo"
                                style="margin-top:0" />
                        </h3>
                        <p class="text-center p-10 text-gray-700">Give your customers a handy way to send you Screen
                            Recordings right
                            from your Helpdesk.</p>
                    </div>
                </div>
                <div v-else-if="integration_type == 'freshchat'"
                    class="sidebar_gradient hidden lg:flex flex-grow md:flex-grow-0 md:w-1/3 bg-gray-100 flex-col justify-center px-4">
                    <div class="">
                        <h3 class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/freshchat-logo.svg" width="140" alt="Helpscout Logo"
                                class="helpscout-logo" />
                        </h3>
                        <p class="text-center p-10 text-gray-700">Give your customers a handy way to send you Screen
                            Recordings right
                            from your Helpdesk.</p>
                    </div>
                </div>
                <div v-else-if="integration_type == 'jira'"
                    class="sidebar_gradient hidden lg:flex flex-grow md:flex-grow-0 md:w-1/3 bg-gray-100 flex-col justify-center px-4">
                    <div class="">
                        <h3 class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/jsm-logo.svg" width="35" alt="Helpscout Logo" class="helpscout-logo" />
                        </h3>
                        <p class="text-center p-10 text-gray-700">Give your customers a handy way to send you Screen
                            Recordings right
                            from your Helpdesk.</p>
                    </div>
                </div>
                <div v-else
                    class="hidden md:flex flex-grow md:flex-grow-0 md:w-1/2 lg:w-1/3 flex-col justify-center px-4 bg-gradient-to-b from-blueberry1 to-blueberry2 text-white">

                    <div class="font-space uppercase text-center px-5 text-md lg:text-lg xl:text-xl">Trusted by 1600+
                        support
                        teams,<br />
                        from startups to enterprises
                    </div>

                    <div class="flex flex-wrap justify-center gap-8 mt-16 px-2 xl:px-3">
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Agorapulse.svg" alt="logo" class="h-5 lg:h-6 xl:h-7" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/ai21labs.svg" alt="logo" class="h-5 lg:h-6 xl:h-7" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Aula.svg" alt="logo" class="h-5 lg:h-6 xl:h-7" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Holded.svg" alt="logo" class="h-5 lg:h-6 xl:h-7" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Kiute.png" alt="logo" class="h-4 lg:h-5 xl:h-6" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Onecom.svg" alt="logo" class="h-5 lg:h-6 xl:h-7" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Pennylane.svg" alt="logo" class="h-5 lg:h-6 xl:h-7" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Shiftcare.svg" alt="logo" class="h-3 lg:h-4 xl:h-5" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Signaturit.svg" alt="logo" class="h-7 lg:h-8 xl:h-9" />
                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/clients/Zenput.svg" alt="logo" class="h-5 lg:h-6 xl:h-7" />
                        </div>

                    </div>

                    <div v-if="false" class="flex flex-row pb-4 justify-center w-full max-w-sm mx-auto">
                        <span>This is how your recorder<br /> might look like</span>

                        <div class="text-center">
                            <img class="mt-3 w-20 h-10" src="/img/arrow_onboarding_2.svg" />
                        </div>
                    </div>
                    <div v-if="false" class="flex flex-row py-4 justify-start w-full max-w-sm mx-auto">
                        <div class="flex self-center align-center">
                            <div class="is_ok text-lg flex flex-row items-center justify-start">
                                <vue-feather type="codesandbox" class="right-1/2 w-12 text-indigo-600 mr-3"
                                    style="overflow:visible;" />
                                <div class="text-left">
                                    <strong>{{ company_name }}</strong>&nbsp;is requesting a video recording of your
                                    screen.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="false"
                        class="videobox stain light flex w-full rounded-lg max-w-sm mx-auto shadow-2xl bg-indigo-600">
                        <div class="content flex flex-col justify-center align-center flex-grow mt-5 text-white">
                            <div class="message my-3 text-center flex flex-col">
                                <div class="icons mb-3 flex flex-row justify-center">
                                    <div class="img monitor mr-3 self-center">
                                        <vue-feather type="monitor" class="h-7 w-7"></vue-feather>
                                    </div>
                                    <div class="img mic self-center">
                                        <vue-feather type="mic" class="h-6 w-6"></vue-feather>
                                    </div>
                                </div>
                                <p class="text-lg">Screen recording &amp; audio</p>
                            </div>
                            <div class="actions mt-5 mb-10 flex justify-center">
                                <div href="#"
                                    class="big-button flex flex-col self-center justify-center rounded-2xl  w-20 h-20 transform duration-150 ease-in-out hover:scale-100 shadow-lg bg-white">
                                    <div class="icon flex justify-center flex-grow">
                                        <div class="align-self-center mt-5">
                                            <div class="rounded-full bg-red-500 h-5 w-5"></div>
                                        </div>
                                    </div>
                                    <div
                                        class="label flex justify-center mb-2 text-sm font-semibold uppercase text-black">
                                        Record
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>







            </div>


        </div>



        <!-- <jet-dialog-modal ref="modal" :show="show_modal_company" maxWidth="lg" @close="show_modal_company = false">
            <template v-slot:title>
                <div class="flex items-center text-gray-700">
                    <vue-feather type="help-circle" class="h-6 w-6 mr-2" />
                    <span class="text-blue-600 font-bold mr-2">Logiwa Support</span><span> already exists</span>
                </div>
            </template>
            <template v-slot:content>

                <div class="text-gray-600">
                    <p>It looks like this company name already exists. If you want to join an existing account then you’d better cancel and ask for an invitation to the account owner.</p>
                    <p class="mt-3">Otherwise, just keep opening a new account with this name.</p>
                </div>

            </template>
            <template v-slot:footer>
                <div class="flex w-full flex-col justify-center ">

                    <div class="flex w-full justify-center">
                        <jet-secondary-button
                            @click.prevent="show_modal_company = false">
                            Cancel or change Company name
                        </jet-secondary-button>
                    </div>

                    <div class="flex w-full mt-5 justify-center">
                        <jet-button
                            @click.prevent="confirmCopy"
                            class="place-content-center">
                            Go ahead I want to open a new account!
                        </jet-button>
                    </div>

                </div>
            </template>
        </jet-dialog-modal> -->

    </blank-layout>
</template>

<script>

import BlankLayout from "@/Layouts/BlankLayout"
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetButton from '@/Jetstream/Button'
//import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetForm from '@/Jetstream/Form'
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetLabel from '@/Jetstream/Label'
import OptionsRadio from '@/Components/UI/OptionsRadio'
//import JetDialogModal from '@/Jetstream/DialogModal'
const CancelToken = axios.CancelToken;
let cancel;
import moment from 'moment-timezone';
import { useTippy } from 'vue-tippy'

export default {
    props: [
        'google_ids', //[email,id,name]
        'shopify', //[shop,shopname]
        'integration_type',
        'integration_email',
        'integration_fullname',
        'integration_team',
        'integration_id',
        'agent_timezone',
        'details',
        'request_email',
    ],


    components: {
        BlankLayout, JetInput, JetInputError, JetLabel,
        JetButton, JetForm, JetActionMessage, OptionsRadio,
        //JetDialogModal, JetSecondaryButton,

    },
    data() {
        return {
            form: this.$inertia.form({
                fullname: '',
                email: '',
                company: '',
                timezone: '',
                job: 'other',
                gid: this.google_ids.id
            }),
            show_info_company: false,
            show_info_email: false,
            timeout: Object,
            buffer: 400,
            lastTypeMoment: 0,
            searching: false,
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            sso_redirect: null
        }
    },
    created() {
        if (this.agent_timezone != '') {
            this.form.timezone = this.agent_timezone
        } else {
            this.moment = moment;
            this.form.timezone = this.moment.tz.guess()
        }


        if (this.google_ids.name != "") {
            this.form.fullname = this.google_ids.name
        } else if (this.integration_fullname != "") {
            this.form.fullname = this.integration_fullname
        }

        if (this.google_ids.email != "") {
            this.form.email = this.google_ids.email
        } else if (this.integration_email != "") {
            this.form.email = this.integration_email
        } else if (this.request_email != "") {
            this.form.email = this.request_email
            this.testEmail()
        }

        if (this.integration_team != "") {
            this.form.company = this.integration_team
        }

    },
    beforeUnmount() {

    },
    mounted() {

        // const instance = useTippy(this.$refs.email)
        //console.log(instance)
        //instance.show()
    },
    computed: {
        company_name() {
            if (this.form.company != '') {
                return this.form.company
            }
            return "Empire"
        },
        is_complete() {
            if (this.validateNotempty(this.form.fullname)
                && this.validateEmail(this.form.email)
                && this.validateNotempty(this.form.company)
                && this.form.fullname.length > 2
                && this.form.company.length > 2
                && this.form.job.length > 2
                && this.show_info_company == false
                && this.show_info_email == false
                && !this.sso_redirect) {
                return true
            }
            return false
        }
    },
    methods: {
        show_email_tip() {
            return true
        },
        updatedJob(value) {
            //console.log("updatedJob", value)
            this.form.job = value
        },
        changeEmailValue(value) {

            if (this.validateEmail(value)) {

                this.form.email = value

                let now = new Date().getTime();
                if (now - this.lastTypeMoment < this.buffer) {
                    clearTimeout(this.timeout);
                }
                if (this.searching) {
                    this.cancel();
                }
                this.timeout = setTimeout(function () { this.testEmail() }.bind(this), this.buffer);
                this.lastTypeMoment = now;

            } else {
                this.show_info_email = false
            }
        },
        changeCompanyName(value) {
            //return
            this.form.company = value
            if (value.length > 2) {
                //this.show_info_company = false
                let now = new Date().getTime();
                if (now - this.lastTypeMoment < this.buffer) {
                    clearTimeout(this.timeout);
                }
                if (this.searching) {
                    this.cancel();
                }
                this.timeout = setTimeout(function () { this.testCompanyName() }.bind(this), this.buffer);
                this.lastTypeMoment = now;
            } else {
                clearTimeout(this.timeout);
            }

        },
        cancel() {
            cancel();
        },
        testCompanyName() {
            if (!this.form.company || !this.validateNotempty(this.form.company) || this.form.company.length <= 2) {
                this.show_info_company = false;
                this.sso_redirect = null;
                return;
            }
            this.searching = true
            var self = this
            let url = this.$page.props.app_url + '/letsgo/search';
            var params = { company: this.form.company };
            axios.post(url, params, {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancel = c;
                })
            })
                .then(response => {
                    if (response.data.exists) {
                        self.show_info_company = response.data.exists == "yes"
                    }
                    self.searching = false;
                })
                .catch(function (thrown) {
                    if (axios.isCancel(thrown)) {
                        //ok
                    } else {
                        console.error(thrown)
                    }
                    self.searching = false;
                });
            //console.log("testCompanyName for:",this.form.company)
        },
        testEmail() {
            if (!this.form.email || !this.validateEmail(this.form.email)) {
                this.show_info_email = false;
                this.sso_redirect = null;
                return;
            }
            this.searching = true
            var self = this
            let url = this.$page.props.app_url + '/letsgo/search';
            var params = { email: this.form.email };
            axios.post(url, params, {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancel = c;
                })
            })
                .then(response => {
                    //console.log(response.data)
                    self.sso_redirect = response.data.sso_redirect
                    if (response.data.exists) {
                        self.show_info_email = response.data.exists == "yes"
                    }
                    self.searching = false;
                })
                .catch(function (thrown) {
                    if (axios.isCancel(thrown)) {
                        //ok
                    } else {
                        console.error(thrown)
                    }
                    self.searching = false;
                });
            //console.log("testCompanyName for:",this.form.company)
        },
        submitSignup() {
            // this.show_info_company = !this.show_info_company;
            // return

            if (this.searching || !this.is_complete) {
                return
            }

            this.form.post(route('letsgo.create'), {
                errorBag: 'submitSignup',
                preserveScroll: true,
                onSuccess: () => {
                    this.form.reset()
                },
                onError: () => {
                    if (this.form.errors.email) {
                        this.form.reset('email')
                        this.$refs.email.focus()
                    }
                    // if (this.form.errors.company) {
                    //     this.form.reset('company')
                    //     this.$refs.company.focus()
                    // }
                }
            })
        },
        validateEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateNotempty(value) {
            var re = /^\s*\S+.*/;
            return re.test(value);
        }
    }
}
</script>

<style scoped>
.sidebar_gradient {
    background: -webkit-linear-gradient(#fafbfc, #e2e5e7);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}


.slide-fade-enter-active {
    transition: all .3s ease-out;
}

.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}
</style>
